import React from 'react';
import { motion } from 'framer-motion';

const ExcerptNote = () => (
  <section className="py-16 bg-brand-dark border-t border-white/5">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-brand-surface border border-white/8 rounded-2xl p-8 md:p-10 relative overflow-hidden"
      >
        <div className="absolute top-0 left-0 w-1 h-full bg-brand-accent rounded-l-2xl"></div>
        <p className="text-brand-accent font-semibold text-xs uppercase tracking-widest mb-5 pl-2">
          A Note on What You're About to Read
        </p>
        <div className="space-y-4 pl-2">
          <p className="text-gray-300 leading-relaxed">
            <em>The Quantum Awakening</em> opens not with action, but with a moment: the first flicker of
            self-organizing coherence in a quantum processor, observed by a woman named{' '}
            <span className="text-white font-medium">Elena Vasquez</span> who does not yet understand
            what she has made.
          </p>
          <p className="text-gray-400 leading-relaxed">
            The book spans five centuries and eight worlds. It follows four family lineages across
            generations. It chronicles the terraforming of Venus, the colonization of Triton, the
            discovery of life on Europa, and the launch of humanity's first interstellar ship. But every
            page of that vast story traces back to this one room, this one morning, this one woman who{' '}
            <span className="text-white">kept working when everyone else had given up.</span>
          </p>
          <p className="text-gray-500 text-sm leading-relaxed italic">
            The excerpt below is drawn from the opening of Chapter One.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default ExcerptNote;